export const vKShareButtonMetaData = {
    isRepeatable: false
}
